import authRequest from "@/api/http/authRequest";
import axios from "axios";


export default {
  getHeaders ( cb: (response) => void, errCb: (response) => any) {
    authRequest.get(`/admin/learning-sessions/headers`, {}, cb, errCb)
  },
  getRoundInSessions ( cb: (response) => void, errCb: (response) => any) {
    authRequest.get(`/admin/learning-sessions/round-in-sessions`, {}, cb, errCb)
  },
  getSessionNumbers ( cb: (response) => void, errCb: (response) => any) {
    authRequest.get(`/admin/learning-sessions/session-numbers`, {}, cb, errCb)
  },
  search (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.post(`/admin/learning-sessions/search?page=${params.page}`, params, cb, errCb)
  },
  upload (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.post(`/admin/learning-sessions`, params ,cb, errCb)
  },
  uploadAdd (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.post(`/admin/learning-sessions/add`, params ,cb, errCb)
  },
  deleteAll (params: any, cb: (response) => void, errCb: (response) => any) {
    const accessToken = localStorage.ACCESS_TOKEN
    axios({
      method: 'post',
      url: `${process.env.VUE_APP_API}/admin/learning-sessions/delete/all`,
      responseType: 'blob',
      data: params,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }).then(cb)
      .catch(async (error) => {
        if (error.response && error.response.data instanceof Blob) {
          try {
            const text = await error.response.data.text()
            const errorData = JSON.parse(text)
            error.response.data = errorData
          } catch (e) {
            console.error('Error parsing blob response:', e)
          }
        }
        errCb(error)
      })
  },
  delete(id: number, cb: (response) => void, errCb: (response) => any) {
    authRequest.delete(`/admin/learning-session/${id}` ,cb, errCb)
  },
  getMilestones(cb: (response) => void, errCb: (response) => any) {
    authRequest.get(`/admin/learning-milestones`, {} ,cb, errCb)
  },
  download (params: any, cb: (response) => void, errCb: (response) => any) {
    const accessToken = localStorage.ACCESS_TOKEN
    axios({
      method: 'post',
      url: `${process.env.VUE_APP_API}/admin/learning-sessions/excel`,
      responseType: 'blob',
      data: params,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }).then(cb)
      .catch(errCb)
  },
}
